import type { WaterDensityPwCalculator } from "../d";
export const waterDensityPwCalculator: WaterDensityPwCalculator = params => {
  const { waterVolumeFactorBBLSTB, waterSpecificGravity } = params;

  const waterDensityLBMFT3 =
    (62.4 * waterSpecificGravity) / waterVolumeFactorBBLSTB;

  return {
    waterDensityLBMFT3
  };
};
